import { Controller } from '@hotwired/stimulus';

export default class NotificationsController extends Controller {
  static targets = ['list']
  static values = {
    markAllUrl: String,
    updateError: String,
    locale: String,
  }

  filter(event) {
    this.#refreshList(event.target.value);
  }

  openNotification(event) {
    const { id, href } = event.params;
    window.open(href, '_blank');
    this.#markAsRead(id).then(() => this.#refreshList(this.#currentFilter()));
  }

  markAllAsRead() {
    fetch(this.markAllUrlValue, {
      method: 'PUT',
      headers: this.#headers(),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Failed');
        this.#refreshList(this.#currentFilter());
      })
      .catch(() => this.#showError());
  }

  async #refreshList(filter) {
    const url = `/${this.localeValue}/mon-compte/notifications?filter=${filter}`;

    try {
      const response = await fetch(url, { headers: { 'Accept': 'text/html' } });
      if (!response.ok) throw new Error('Failed');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newList = doc.querySelector('#notifications');

      if (newList) {
        this.listTarget.innerHTML = newList.innerHTML;
      }
    } catch (error) {
      this.#showError();
    }
  }

  async #markAsRead(id) {
    try {
      const response = await fetch(`/mon-compte/profile_notifications/${id}`, {
        method: 'PUT',
        headers: this.#headers(),
      });
      if (!response.ok) throw new Error('Failed');
    } catch (error) {
      this.#showError();
    }
  }

  #currentFilter() {
    const checked = this.element.querySelector('input[name="filter"]:checked');
    return checked ? checked.value : 'all';
  }

  #headers() {
    return {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
      'Accept': 'text/html',
    };
  }

  #showError() {
    if (typeof toastr !== 'undefined') {
      toastr.error(this.updateErrorValue);
    }
  }
}
